//import React from 'react'
//import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import './app.scss'
import './fawesome'
import App from './App'
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container)
root.render(<App />);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

